var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m81.668 93.16h-21.68c-1.1055 0-2-0.89453-2-2v-82.32c0-1.1055 0.89453-2 2-2h21.68c1.1055 0 2 0.89453 2 2v82.316c0 1.1094-0.89844 2.0039-2 2.0039zm-41.656 0h-21.68c-1.1055 0-2-0.89453-2-2v-82.32c0-1.1055 0.89453-2 2-2h21.68c1.1055 0 2 0.89453 2 2v82.316c0 1.1094-0.89844 2.0039-2 2.0039z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpPause);
export default __webpack_public_path__ + "static/media/np_pause.9e916f13f7472dfeaf786be5e982d708.svg";
export { ForwardRef as ReactComponent };